<script>
    import {onMount} from 'svelte';
    import gsap from "gsap";
    import {labels, mainTimeline} from "../timelines/main-timeline";

    const timeline = gsap.timeline();
    const {gnosisStart} = labels;
    const duration = 2.14;

    onMount(() => {

        timeline.from('.grid', {
            duration,
            opacity: 0,
            y: 100,
            ease: 'out',
        })

        mainTimeline.add(timeline, gnosisStart);
    });

</script>

<image class="grid" width="1920" height="1080" x="0" xlink:href="images/grid.png"></image>
